// extracted by mini-css-extract-plugin
export default {"label":"VehicleDriveability-module__label--m9Q3z"};